import CryptoJS from 'crypto-js';

// username
const Username = 'web.1.0.beta';
// secret
const Secret = 'TkoWuEN8cpDJubb7Zfwxln16NQDZIc8z';

export function signFn(config: {
  headers: Record<string, string>;
  method: string;
  data?: Record<string, string>;
  url?: string;
}) {
  const { headers, method, data } = config;
  const xDate = new Date().toUTCString();
  let Digest = '';

  let body_json = '';
  if (method === 'POST' || method === 'PUT') {
    const body = data;
    body_json = JSON.stringify(body);
  }

  const body_digest = CryptoJS.SHA256(body_json).toString(CryptoJS.enc.Base64);
  Digest = `SHA-256=${body_digest}`;

  const signing_str = `x-date: ${xDate}\ndigest: ${Digest}`;
  const sign = CryptoJS.HmacSHA1(signing_str, Secret).toString(
    CryptoJS.enc.Base64
  );

  const auth = `hmac username="${Username}", algorithm="hmac-sha1", headers="x-date digest", signature="${sign}"`;

  headers['x-date'] = xDate;
  headers['Authorization'] = auth;

  if (Digest) {
    headers['Digest'] = Digest;
  }

  return config;
}

// const headers = {
//   Host: Host,
//   Accept: Accept,
//   'Content-Type': ContentType,
//   'x-date': xDate,
//   Authorization: auth,
// };

// if (Digest) {
//   headers['Digest'] = Digest;
// }

// let ret;

// if (HTTPMethod === 'GET') {
//   ret = fetch(Url, { method: 'GET', headers });
// } else if (HTTPMethod === 'POST') {
//   ret = fetch(Url, { method: 'POST', headers, body: body_json });
// }

// ret
//   .then((response) => {
//     console.log(response.headers);
//     return response.text();
//   })
//   .then((data) => {
//     console.log(data);
//   })
//   .catch((error) => {
//     console.error('Request failed:', error);
//   });
